import { StringMappingType } from "typescript";
import { StatusIntent } from "../types/orderIntent";
import callApi, { BaseResponseDto, BaseResponsePagedDto, callApiBlob } from "./baseRequest";
import moment from "moment";
const routeIntent = 'order-intent';

export interface RequestOrderIntent {
    shipmentDate?: Date,
    shipmentQuantity: number,
    orderMaterial: string,
    orderItem: string,
    orderNumber: string,
    transporterCode?: string,
    transporterName?: string,
    veichleType: string,
    veichleTypeName: string,
    comment?: string,
    receiverCode?: string,
    isPVC?: boolean,
    materialCode?: string,
    materialDescription?: string,
    paymentCondition?: string,
    paymentConditionDescription?: string,
    customerCode: string,
    incoterms?: string,
    unitMeasurement: string,
    isRecused: boolean,
    recusedComment?: string
    id: string,
    orderIntentGroupId?: string,
    deliveryDate?: Date,
}

export interface ResponseOrderIntent {
    id: string,
    shipmentDate?: Date,
    shipmentQuantity: number,
    orderMaterial: string,
    orderItem: string,
    orderNumber: string,
    transporterCode?: string,
    transporterName?: string,
    veichleType: string,
    comment?: string,
    receiverCode?: string,
    receiverName?: string,
    isPVC?: boolean,
    materialCode?: string,
    materialDescription?: string,
    paymentCondition?: string,
    paymentConditionDescription?: string,
    customerCode: string,
    incoterms?: string,
    unitMeasurement: string,
    intentNumber: string,
    status: StatusIntent,
    uniparAnalisysDate?: Date,
    pedingCustomerDate?: Date,
    history: ResponseOrderIntent,
    update: boolean,
    remove: boolean,
    recusedComment?: string,
    veichleTypeName: string,
    orderIntentGroupEntityId?: string,
    intentGroupNumber?: string,
    deposit?: string|undefined
    deliveryDate?: Date,
}

export interface ResponseOrderIntentGroup {
    id: string,
    isPVC?: boolean,
    materialCode?: string,
    materialDescription?: string,
    customerCode: string,
    customerName: string,
    incoterms?: string,
    status: StatusIntent,
    intentGroupNumber?: string,
}

export interface ResponseOrderReportData{
    quantityOrders: number,
    quantitiyTonOrders: number,
    quantityEditedOrders: number,
    quantitiyTonEditedOrders: number,
    quantityOrdersCanceled: number,
    quantitiyTonCanceledOrders: number,
    products: ReponseOrderProduct[],
    quantitiyTonOrdersPortal: number,
    quantitiyTonOrdersSAP: number,
    quantitiyTonCanceledOrdersPortal:number,
    quantitiyTonCanceledOrdersSAP: number,
    quantityOrdersPortal: number,
    quantityOrdersSAP: number,
    quantityOrdersCanceledPortal: number,
    quantityOrdersCanceledSAP:number


}

export interface ReponseOrderProduct{
    materialCode: string,
    materialDescription: string,
	quantitiyTonOrders: number,
	quantityTonOrdersEdited: number,
	quantitiyTonCanceledOrders: number
}

export interface RequestOrderReportData{
    orderDateInitial: any,
    orderDateFinal: any,
    customerCodes: [],
    materialCodes: [],
    typeOrder: string,
    materialType?: number,
    country?: string
}

export function postOrderIntent(body: RequestOrderIntent[]): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        data: null,
        success: false
    };

    const response = callApi('POST', `${routeIntent}/create`, body)
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
        }
        else {
            result.error = 'Erro ao criar solicitação de pedido por favor tente novamente.'
        }
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function getOrderIntent(
    take: number,
    skip: number,
    search: string,
    materialCode: string,
    idGroup: string,
    status: string,
    country: string = 'BR',
    isPVC?: boolean | null): Promise<BaseResponsePagedDto<ResponseOrderIntent[]>> {
    const result: BaseResponsePagedDto<ResponseOrderIntent[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: take,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi(
        'GET',
        `${routeIntent}/?take=${take}&skip=${skip}&isPVC=${isPVC}&search=${search}&materialCode=${materialCode}&idGroup=${idGroup}&country=${country}&status=${status}`
    )
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
            result.data = resp?.data;
            result.totalItems = resp?.totalItems;
            result.totalPages = resp?.totalPages;
        }
        else {
            result.error = result.error
        }
        return result;
    })
    .catch(err => {
        result.error = err.error;

        return result;
    })

    return response;
};

export function getOrderIntentGroup(
    take: number,
    skip: number,
    search: string,
    country: string,
    isPVC?: boolean | null): Promise<BaseResponsePagedDto<ResponseOrderIntentGroup[]>> {
    const result: BaseResponsePagedDto<ResponseOrderIntentGroup[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: take,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi(
        'GET',
        `${routeIntent}/group/?take=${take}&skip=${skip}&isPVC=${isPVC}&search=${search}&country=${country}`
    )
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
            result.data = resp?.data;
            result.totalItems = resp?.totalItems;
            result.totalPages = resp?.totalPages;
        }
        else {
            result.error = result.error
        }
        return result;
    })
    .catch(err => {
        result.error = err.error;

        return result;
    })

    return response;
};

export function getOrderIntentGroupFilter(
    take: number,
    skip: number,
    search: string,
    country: string,
    status: string,
    isPVC: string,
    startDate: string,
    endDate: string
): Promise<BaseResponsePagedDto<ResponseOrderIntentGroup[]>> {
    const result: BaseResponsePagedDto<ResponseOrderIntentGroup[]> = {
        error: '',
        data: [],
        success: false,
        currentTake: take,
        totalItems: 0,
        totalPages: 0
    };

    const response = callApi(
        'GET',
        `${routeIntent}/group-filter/?take=${take}&skip=${skip}&isPVC=${isPVC}&search=${search}&country=${country}&status=${status}&startDate=${startDate}&endDate=${endDate}`
    )
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
            result.data = resp?.data;
            result.totalItems = resp?.totalItems;
            result.totalPages = resp?.totalPages;
        }
        else {
            result.error = result.error
        }
        return result;
    })
    .catch(err => {
        result.error = err.error;

        return result;
    })

    return response;
};

export function putOrderIntentHistory(body: RequestOrderIntent[]): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        data: null,
        success: false
    };

    const response = callApi('PUT', `${routeIntent}/alter-history`, body)
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
        }
        else {
            result.error = 'Erro ao atualizar os pedidos, por favor tente novamente.'
        }
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function GetReportData(body: RequestOrderReportData, language: string): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        data: null,
        success: false
    };

    const response = callApi('POST', `${routeIntent}/orders-quantities/${language}`, body)
    .then(resp => {
        if (resp?.error == null ?? false) {
            result.success = true;
            result.data = resp.data;
        }
        else {
            result.error = 'An error occurred while generating the report.';
        }
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function getFileReport(
    language: string,
    type: string,
    body: RequestOrderReportData) : Promise<boolean>
{
    let url = `${routeIntent}/file-orders-quantities/${language}/${type}`;

    const p = callApiBlob(
        'POST',
        url,
        body
    )
    .then((resp) => {
        const blob = new Blob([resp as BlobPart], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = `${type}_${moment().format('DD-MM-yyyy')}.xlsx`;
        document.body.appendChild(element);
        element.click();

        return true;
    })
    .catch(err => {
        return false;
    })

    return Promise.resolve(p);
};
